// extracted by mini-css-extract-plugin
export default {"root":"v4_RKn1TZ6ZsW4SsGV3k","width-default":"q2HEf7eRVFpvezaTrWPT","width-100%":"BoPOjuGf0wCTWnZSeVRF"};